import { BiteLogDeviceEvent } from './bite_log_device_event.js';

export function name(event: BiteLogDeviceEvent): string {
  switch (event) {
    case BiteLogDeviceEvent.AppUpdate:
      return 'app-update';
    case BiteLogDeviceEvent.ApnReceivedDeprecated:
      return 'apn-received';
    case BiteLogDeviceEvent.ApplicationIsBeingLoggedOut:
      return 'application-is-being-logout';
    case BiteLogDeviceEvent.ApplicationIsBeingTerminated:
      return 'application-is-being-terminated';
    case BiteLogDeviceEvent.BatteryDepleting:
      return 'battery-depleting';
    case BiteLogDeviceEvent.BatteryStateChange:
      return 'battery-state-change';
    case BiteLogDeviceEvent.BluetoothStateChange:
      return 'bluetooth-state-change';
    case BiteLogDeviceEvent.BridgeEvalError:
      return 'bridge-eval-error';
    case BiteLogDeviceEvent.CameraInitializationError:
      return 'camera-initialization-error';
    case BiteLogDeviceEvent.ConfigChange:
      return 'config-change';
    case BiteLogDeviceEvent.CrashlyticsCrash:
      return 'crashlytics-crash';
    case BiteLogDeviceEvent.EnteredMenu:
      return 'entered-menu';
    case BiteLogDeviceEvent.EmptyJS:
      return 'empty-js';
    case BiteLogDeviceEvent.ErrorSendingOrder:
      return 'error-sending-order';
    case BiteLogDeviceEvent.ExitMenuToConfigScreen:
      return 'exit-menu-to-config-screen';
    case BiteLogDeviceEvent.FailedOrderCreation:
      return 'failed-order-creation';
    case BiteLogDeviceEvent.FailedOrderValidation:
      return 'failed-order-validation';
    case BiteLogDeviceEvent.FailedToDownloadMenuAssets:
      return 'failed-to-download-menu-assets';
    case BiteLogDeviceEvent.FailedToEnterASAM:
      return 'failed-to-enter-asam';
    case BiteLogDeviceEvent.FailedToExitASAM:
      return 'failed-to-exit-asam';
    case BiteLogDeviceEvent.FailedToStartWebView:
      return 'failed-to-start-webview';
    case BiteLogDeviceEvent.GarconHealthCheckFailed:
      return 'garcon-health-check-failed';
    case BiteLogDeviceEvent.GarconJsCrash:
      return 'garcon-js-crash';
    case BiteLogDeviceEvent.GcnJsCrash:
      return 'gcn-js-crash';
    case BiteLogDeviceEvent.GcnJsError:
      return 'gcn-js-error';
    case BiteLogDeviceEvent.JawsErrorDeprecated:
      return 'jaws-error';
    case BiteLogDeviceEvent.JawsLicenseDeprecated:
      return 'jaws-license';
    case BiteLogDeviceEvent.KioskEnteredMaintenanceMode:
      return 'kiosk-entered-maintenance-mode';
    case BiteLogDeviceEvent.KioskExitedMaintenanceMode:
      return 'kiosk-exited-maintenance-mode';
    case BiteLogDeviceEvent.KioskUpdatedMaintenanceMode:
      return 'kiosk-updated-maintenance-mode';
    case BiteLogDeviceEvent.LowBattery:
      return 'low-battery';
    case BiteLogDeviceEvent.ManualAppRestart:
      return 'manual-app-restart';
    case BiteLogDeviceEvent.MemoryWarning:
      return 'memory-warning';
    case BiteLogDeviceEvent.MenuCoverTapped:
      return 'menu-cover-tapped';
    case BiteLogDeviceEvent.NativeFailure:
      return 'native-failure';
    case BiteLogDeviceEvent.NativeLog:
      return 'native-log';
    case BiteLogDeviceEvent.NativeTouchGestureBlocked:
      return 'native-touch-gesture-blocked';
    case BiteLogDeviceEvent.NativeTouchGestureOk:
      return 'native-touch-gesture-ok';
    case BiteLogDeviceEvent.NativeTransactionFinished:
      return 'native-transaction-finished';
    case BiteLogDeviceEvent.NativeTransactionStarted:
      return 'native-transaction-started';
    case BiteLogDeviceEvent.NoNotificationPermissions:
      return 'no-notification-permissions';
    case BiteLogDeviceEvent.OK:
      return 'ok';
    case BiteLogDeviceEvent.Push:
      return 'push-received';
    case BiteLogDeviceEvent.ReachabilityNone:
      return 'reachability-none';
    case BiteLogDeviceEvent.ReachabilityOK:
      return 'reachability-ok';
    case BiteLogDeviceEvent.RecoveredFromCrash:
      return 'recovered-from-crash';
    case BiteLogDeviceEvent.ReloadHTML:
      return 'reload-html';
    case BiteLogDeviceEvent.RemoteTestPrintError:
      return 'remote-test-print-error';
    case BiteLogDeviceEvent.RemoteTestPrintSuccess:
      return 'remote-test-print-success';
    case BiteLogDeviceEvent.ScaleData:
      return 'scale-data';
    case BiteLogDeviceEvent.ScaleLog:
      return 'scale-log';
    case BiteLogDeviceEvent.ScannerData:
      return 'scanner-data';
    case BiteLogDeviceEvent.SelfDestructMaxSessionCountReached:
      return 'self-destruct-max-session-count-reached';
    case BiteLogDeviceEvent.SelfDestructNoKitchenPrinter:
      return 'self-destruct-no-kitchen-printer';
    case BiteLogDeviceEvent.SelfDestructNoPayment:
      return 'self-destruct-no-payment';
    case BiteLogDeviceEvent.SelfDestructNoReceiptPrinter:
      return 'self-destruct-no-receipt-printer';
    case BiteLogDeviceEvent.SessionEnded:
      return 'session-ended';
    case BiteLogDeviceEvent.SessionStarted:
      return 'session-started';
    case BiteLogDeviceEvent.SpeedTestResults:
      return 'speed-test-results';
    case BiteLogDeviceEvent.StartFail:
      return 'start-fail';
    case BiteLogDeviceEvent.TransactionOutboxReplaySuccess:
      return 'transaction-outbox-replay-success';
    case BiteLogDeviceEvent.VitrineHealthCheckFailed:
      return 'vitrine-health-check-failed';
    case BiteLogDeviceEvent.VitrineHealthCheckSuccessDeprecated:
      return 'vitrine-health-check-success';
    case BiteLogDeviceEvent.VitrineJsCrash:
      return 'vitrine-js-crash';
    case BiteLogDeviceEvent.WebViewDidCommitNavigation:
      return 'webview-did-commit-navigation';
    case BiteLogDeviceEvent.WebViewDidTerminate:
      return 'webview-did-terminate';
    case BiteLogDeviceEvent.WebViewFailedProvisionalNavigation:
      return 'webview-failed-provisional-navigation';
    case BiteLogDeviceEvent.WebViewRedirectProvisionalNavigation:
      return 'webview-redirect-provisional-navigation';
    case BiteLogDeviceEvent.WhitelistTestFailure:
      return 'whitelist-test-failure';
    case BiteLogDeviceEvent.WhitelistTestSuccess:
      return 'whitelist-test-success';
    case BiteLogDeviceEvent.VitrineNetworkError:
      return 'vitrine-network-error';
    case BiteLogDeviceEvent.KioskReady:
      return 'kiosk-ready';
    case BiteLogDeviceEvent.GarconNetworkError:
      return 'garcon-network-error';
  }
}
